module.exports = __webpack_public_path__ + "static/media/HypeDesign_preview.de2df8cb.jpg";